import { useEffect, useState } from "react";
import { smartSearch } from "./SmartSearchEngine";
import { SeachEditor } from "./SearchEditor";
import getSmartSearchParammeter from "./SmartSearchParammeter";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";

import { useTranslation } from "react-i18next";
import NaturalLanguageInput from "./NaturalLanguageInput";
import { InterviewService } from "../../../../services/InterviewService";
import { toast } from "react-toastify";
import SearchForm from "./Form/SearchForm";

export default function SmartSearchTab() {
  const [result, setresult] = useState([]);
  const [searchText, setSearchText] = useState(``);
  const [feedback, setFeedback] = useState("");
  const [searchObject, setSearchObject] = useState({
    pageNumber: 1,
    pageSize: 10,
    order: 0,
    orderBy: "modifiedDate"
  });
  let { t } = useTranslation();

  const {
    setInterviews,
    setTotalPages,
    setActiveTab,
    orderBy,
    order,
    pageNumber
  } = useAdvanceSearchContext();

  const feedbackRegex = /Expected.*/s;
  const [searchConfig, setSearchConfig] = useState({});
  const [configList, setConfigList] = useState([]);
  useEffect(() => {
    getSmartSearchParammeter().then((parms) => {
      setSearchConfig(parms);
      smartSearch.InitGrammar(parms);
      setConfigList(Object.keys(parms).map((key) => parms[key]));
    });
  }, []);
  function clearText() {
    setSearchText("");
    setresult([]);
    setFeedback("");
    setSearchObject({
      pageNumber: 1,
      pageSize: 10,
      order: 0,
      orderBy: "modifiedDate"
    });
  }

  function onChange(text) {
    let exp = text.split(";");
    let multiple_exp = [];
    let feedback = [];
    for (let i = 0; i < exp.length; i++) {
      let result = smartSearch.parse(exp[i]);

      if (result.success) {
        multiple_exp.push(result.result);
      } else {
        feedback.push(result.result);
      }
    }
    let _searchObj = {
      pageNumber: pageNumber,
      pageSize: 10,
      order: order,
      orderBy: orderBy
    };
    for (let item of multiple_exp) {
      searchConfig[item.field].handler(_searchObj, item.list);
    }

    setSearchText(text);
    // Capture feedback
    if (feedback.length > 0) {
      let feedbackText = "";
      for (let item of feedback) {
        feedbackText += item + "\n";
      }
      setFeedback(feedbackText);
    } else {
      setFeedback("");
    }
    setSearchObject(_searchObj);
  }

  function onsubmit() {
    let _searchObject = { ...searchObject };

    Object.keys(_searchObject).map((key) => {
      configList.map((config) => {
        if (config.id === key) {
          config.handleValues(_searchObject);
        }
      });
    });

    callSearchService(_searchObject);
  }

  function callSearchService(_searchObject) {
    let pageNumber = _searchObject.pageNumber;
    let pageSize = _searchObject.pageSize;
    InterviewService.advanceSearch(_searchObject, pageSize, pageNumber).then(
      (data) => {
        setInterviews(data.page);
        setTotalPages(Math.ceil(data.total / pageSize));
        setActiveTab("searchResults");
        if (data.total === 0) toast.warning(t("No results found."));
      }
    );
  }
  function onChangeSearchObject(event) {
    setSearchObject({
      ...searchObject,
      [event.target.name]: event.target.value
    });
  }

  return (
    <div className="m-5">
      <div className="row">
        <div className="col text-end">
          <button className="app-button btn-second btn-md" onClick={clearText}>
            {t("Clear")}
          </button>
          <button className="app-button btn-prime btn-md" onClick={onsubmit}>
            {t("Search")}
          </button>
        </div>
      </div>
      <div className="row  ">
        <div className="col">
          <legend className="fontsize-legend">{t("Advance Query")}</legend>
          <NaturalLanguageInput
            searchConfig={searchConfig}
            setquery={onChange}
          />
        </div>
        {/* <div className=" col">
          <SeachEditor
            onChangeText={onChange}
            text={searchText}
            search={searchConfig}
            submit={onsubmit}
            feedback={feedback}
            clearText={clearText}
          />
        </div> */}
      </div>{" "}
      <div className="row    mb-5" style={{ marginTop: "100px" }}>
        <SearchForm
          searchObject={searchObject}
          setSearchObject={setSearchObject}
          onChange={onChangeSearchObject}
          searchConfig={configList}
          t={t}
        />
      </div>
    </div>
  );
}
